import { defineComponent as _defineComponent } from 'vue';
import DirectiveHelp from "./DirectiveHelp.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'DirectiveHelpSection',
    props: {
        directives: null,
        mode: null
    },
    setup(__props) {
        return { __sfc: true, DirectiveHelp };
    }
});
